import { render, staticRenderFns } from "./ShopSearchSection.vue?vue&type=template&id=97e87724&"
import script from "./ShopSearchSection.vue?vue&type=script&lang=js&"
export * from "./ShopSearchSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports